import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';
import { getDirectDebitAccounts } from 'shared/api/directDebitAccountsApi';

export let fetchDirectDebitAccount = createAsyncThunk(
  'directDebit/fetchDirectDebitAccount',
  (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const { compid: companyId } = state.companies.selectedCompany ?? { compid: 0 };

    return getDirectDebitAccounts(companyId);
  },
);

